import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetFormStructuresRequest = App.Http.Requests.FormStructure.GetFormStructuresRequest;
import GetFormStructuresResponse = App.Http.Responses.FormStructure.GetFormStructuresResponse;
import GetFormStructureResponse = App.Http.Responses.FormStructure.GetFormStructureResponse;

class UserStructureApi extends TenantBaseApi {
    /**
     * Get list of form user structures
     *
     * - Request: GetFormStructuresRequest
     * - Response: GetFormStructuresResponse
     */
    async index(request: GetFormStructuresRequest): Promise<GetFormStructuresResponse> {
        return await this.get<GetFormStructuresResponse, GetFormStructuresRequest>("/user-structures", {
            params: request,
        });
    }

    async registration(systemName: string): Promise<GetFormStructureResponse> {
        return await this.get<GetFormStructureResponse, void>(`/registration-structures/${systemName}`, {
            silentError: true,
        });
    }
}

export const userStructureApi = new UserStructureApi();
